<div class="row harp-workflow-line">
  <hr />
</div>
<div class="row harp-workflow">
  <div
    class="col-4 harp-reg-status"
    [class.active]="isProfileInfo"
    [class.visited]="isAccountInfo || isConfirmation"
  >
    <div class="harp-status-indicator">
      <span [hidden]="isProfileInfo">
        <em class="icon ion-md-checkmark"></em>
      </span>
      <span [hidden]="!isProfileInfo"> 1 </span>
    </div>
    <div class="harp-status-label">Profile Information</div>
  </div>
  <div
    class="col-4 harp-reg-status"
    [class.active]="isAccountInfo"
    [class.visited]="isConfirmation"
  >
    <div class="harp-status-indicator">
      <span [hidden]="isProfileInfo || isAccountInfo">
        <em class="icon ion-md-checkmark"></em>
      </span>
      <span [hidden]="isConfirmation"> 2 </span>
    </div>
    <div class="harp-status-label">Account Information</div>
  </div>
  <!-- <div
    class="col-3 harp-reg-status"
    [class.active]="isRemoteProofing"
    [class.visited]="isConfirmation"
  >
    <div class="harp-status-indicator">
      <span [hidden]="isProfileInfo || isAccountInfo || isRemoteProofing">
        <em class="icon ion-md-checkmark"></em>
      </span>
      <span [hidden]="isConfirmation"> 3 </span>
    </div>
    <div class="harp-status-label">Remote Proofing</div>
  </div> -->
  <div class="col-4 harp-reg-status" [class.active]="isConfirmation">
    <div class="harp-status-indicator">3</div>
    <div class="harp-status-label">Confirmation</div>
  </div>
</div>
